import { Pipe, PipeTransform } from "@angular/core";
import { TicketEditService } from "../_provider/ticket-edit.service";

@Pipe({
    name: "ToCalculateNameById",
    standalone: false
})
export class ToCalculateNameById implements PipeTransform{

    constructor(private ticketEditSrv: TicketEditService){}

    transform(value: number, ...args: any[]) {
        if(value == -1) return
        return this.ticketEditSrv.toCalculateList.find(l => l.id == value).description
    }

}